module.exports = __webpack_public_path__ + "img/logoObscuro.8ba602a3.png";